module.exports = __webpack_public_path__ + "img/tuiguang2-1.684a1a6e.png";